var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-file"},[_c('input',{ref:"input",staticClass:"custom-file-input",attrs:{"type":"file","id":_vm.id,"aria-describedby":_vm.id},on:{"change":_vm.onChange}}),_c('label',{staticClass:"custom-file-label",attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }